import React, { useState } from "react";
import { LoginContentWrapper, LoginLayout } from "Components";
import RegisterMemberForm from "./RegisterMemberForm";
import RegisterSuccess from "./RegisterSuccess";

const RegisterMember = (): React.JSX.Element => {
  const [isRegisterSuccessful, setIsRegisterSuccessful] = useState(false);
  const [memberEmail, setMemberEmail] = useState("");

  return (
    <LoginLayout>
      {isRegisterSuccessful ? (
        <LoginContentWrapper
          title="Check your email"
          byline={`We've sent a verification link to ${memberEmail}`}
        >
          <RegisterSuccess memberEmail={memberEmail} />
        </LoginContentWrapper>
      ) : (
        <LoginContentWrapper title="Get started with Spectra Assure">
          <RegisterMemberForm
            onSuccess={(email: string) => {
              setIsRegisterSuccessful(true);
              setMemberEmail(email);
            }}
          />
        </LoginContentWrapper>
      )}
    </LoginLayout>
  );
};

export default RegisterMember;
